export const EMPLOYEE_CREATE_PERMISSION = 'employee.create';

export const EMPLOYEE_READ_ANY_PERMISSION = 'employee.read.any';

export const EMPLOYEE_TERMINATE_ANY_PERMISSION = 'employees.events.terminate.any';

export const EMPLOYEE_REHIRE_ANY_PERMISSION = 'employee.rehire.any';

export const EMPLOYEE_EXPORT_ANY_PERMISSION = 'employee.export.any';

export const REQUEST_APPROVE_ANY_PERMISSION = 'request.approve.any';

export const REQUEST_LEAVES_APPROVE_ANY_PERMISSION = 'request.leaves.approve.any';

export const REQUEST_LEAVES_REJECT_ANY_PERMISSION = 'request.leaves.reject.any';

export const TEMPLATES_CREATE_PERMISSION = 'templates.create'; // TODO: Use after IconButton is supported in Button component

export const TEMPLATES_DELETE_ANY_PERMISSION = 'templates.delete.any'; // TODO: Use after IconButton is supported in Button component
